module.exports = __webpack_public_path__ + "img/FrontKingMountainBackground2_w_1400.9417b7b4.jpg";